var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ffe3dd;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{stroke:#f8bd92;stroke-miterlimit:10;stroke-width:2px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 704.2,
    width: 1215.8,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2067.62,200.91c-54.32,98-237.68,100.31-350.34,37.89s-160-192.5-105.64-290.54S1801.33-178.65,1914-116.22,2121.94,102.87,2067.62,200.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1050.44,1175.73c2,131.42-171.11,240.62-312.41,242.77s-257.46-102.63-259.46-234S589.48,944.76,730.78,942.6,1048.44,1044.32,1050.44,1175.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1536.61,354.36c-46.49,27.7-83.08,69.95-142.58,78.43-115.74,16.5-196.71-114.1-312.48-89.63C998,360.82,940.22,434.87,925,506.62c-12.67,59.64,3.65,121.17,38.85,170.07,43.18,60,108.57,94,176.75,118,53.07,18.7,108.19,29.37,164.1,34.55,43.47,4,87.16,5.23,130.8,4.66,49-.63,98.27-3.55,145.88-15.24,60.07-14.74,112.21-45.43,156.79-88.09,37.1-35.51,66.26-79.86,80.27-129.63a228.11,228.11,0,0,0-9.52-151.68A247.43,247.43,0,0,0,1796,423.51C1748,339.62,1621.31,303.9,1536.61,354.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1106.34-8.71c18.16,51.73,68.05,88.9,122.81,91.45a137.07,137.07,0,0,0,91.67-30.07c7.54-6.12,19.28-27.16,3.43-29.44-26.64-3.82-.84,48.78,5.83,56.54,12.72,14.79,30.31,24.64,48.52,31.63a210.71,210.71,0,0,0,112.83,10.23c46.72-8.56,86.26-31.27,135.15-31.64,63.56-.48,121.43,28.32,172,64.58,26,18.68,50.52,39.4,74.84,60.23,25.17,21.55,49.88,42.46,85.69,39.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1939.15,931.78c-29.57-6.46-61.24.67-88.42,12.78-74.25,33.07-128.6,98.67-206.34,125.83-76.15,26.6-162.9,30.4-239.16,2.28-35.83-13.22-69.14-36.86-86.87-70.68-3.23-6.16-6-13-5.24-19.88,2.47-23.09,26.1-11.7,28.18,5.36,4,32.35-26.52,56.34-55.42,61.69-38.11,7.07-77.25-10.91-112.17-23.68-84.18-30.77-163.23-51.26-252-26.63-77.12,21.41-147.39,69.78-191,137.35"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.ce21cf317999343d682d342a13682950.svg";
export { ForwardRef as ReactComponent };